// Top nav. Markup mirrors `nav.top > .nav-inner` from every design HTML
// (see e.g. 01-search.html line 2147). All classes are from kaira-flights.css
// — no inline styling.
//
// Differences from the consumer design:
//   - A Flights / Hotels switch, since one build serves both verticals.
//   - The wallet chip pulls the live partner balance from /auth/me/.
//   - The right-side "Chat with Kaira" CTA is repurposed as a Sign-out button
//     (kept the .nav-cta visual treatment so the page still looks right).

import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { currentVertical, hrefFor, VERTICALS } from "../lib/vertical";

export function Nav() {
  const { me, signOut } = useAuth();
  const nav = useNavigate();
  const balance = me?.partner?.balance ?? 0;
  const vertical = currentVertical();

  return (
    <nav className="top">
      <div className="nav-inner">
        <Link to="/" className="logo">
          <div className="logo-mark">K</div>
          <div className="logo-word">
            <span className="brand">the tarzan way</span>
            <span className="tag">by Kaira · est. 2018</span>
          </div>
        </Link>

        <div className="nav-links">
          {/* Plain anchors, not <Link>: each vertical is mounted under its own
              router basename, so a client-side navigation across them would
              resolve against the wrong prefix. This is a real page load. */}
          {VERTICALS.map((v) => (
            <a
              key={v.key}
              href={hrefFor(v.key)}
              className={v.key === vertical ? "active" : undefined}
            >
              {v.label}
            </a>
          ))}
          <NavLink to="/bookings" className={({ isActive }) => (isActive ? "active" : undefined)}>
            My bookings
          </NavLink>
        </div>

        <div className="nav-right">
          <div className="nav-wallet">
            <span className="dot" />
            {/* The label is the first thing to go on a narrow screen — the
                amount is the part anyone actually reads. */}
            <span className="nav-wallet-label">Wallet ·</span>
            <b>{formatINR(balance)}</b>
          </div>
          <button
            type="button"
            className="nav-cta"
            onClick={async () => {
              await signOut();
              nav("/signin", { replace: true });
            }}
          >
            Sign out
            <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 10L10 2M10 2H4M10 2V8" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
}

function formatINR(n: number): string {
  // Match the design's "₹ 1,24,500" Indian-numerals format.
  try {
    return "₹ " + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n);
  } catch {
    return `₹ ${n.toFixed(0)}`;
  }
}
